import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';
import tpcQuestionApi from './api/questionApiSlice';
import thunk from 'redux-thunk';
import { appStateSlice } from './appStateSlice';

const rootReducer = combineReducers({
    [tpcQuestionApi.reducerPath]: tpcQuestionApi.reducer,
    [appStateSlice.name]: appStateSlice.reducer,
});

export const store = configureStore({
    reducer: rootReducer,
    devTools: process.env.mode !== 'production',
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(thunk).concat(tpcQuestionApi.middleware),
});

export const slices = {
    tpcQuestionApi: tpcQuestionApi,
    appState: appStateSlice,
};

export const actions = {
    appState: appStateSlice.actions,
};

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;

export type TpcRootState = ReturnType<typeof store.getState>;
